import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type CheckboxInputDefinition } from './checkbox-input.definition';

export class CheckboxInputDefinitionMapper implements DefinitionMapper<'checkboxInput'> {
  readonly type = 'checkboxInput';

  extract(
    element: CanvasElementFrom<'checkboxInput'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'checkboxInput'>,
  ): PartialDeep<CheckboxInputDefinition> {
    const { title, input } = element.props.content;

    return {
      label: title?.label,
      showLabel: title?.enabled,
      iconName: title?.icon,
      tooltip: title?.tooltip,
      isReadOnly: input?.readonly,
      styleName: element.props.styleConfig?.styleName,
    };
  }
}
